export { CommonCriteria as CommonCriteriaTooltip } from './CommonCriteria';
